import {
    getModule,
    Module,
    Mutation,
    MutationAction,
    VuexModule,
} from 'vuex-module-decorators';
import {
    setCSRFToken, 
    clearCSRFToken, 
    createCSRFToken, 
    createInquiry 
} from '../api';
import { InquirySubmit } from '../models';
import store from '../../store';

export interface IInquiryState {
    subject: string,
    message: string,
    relatedContent: string,
    name: string,
    email: string,
    company: string,
    isAgreed: boolean,
    has_api_error: boolean,
}

@Module({
    namespaced: true,
    name: 'inquiry',
    store,
    dynamic: true,
})
class Inquiry extends VuexModule implements IInquiryState {
    subject = '';
    message = '';
    relatedContent = '';
    name = '';
    email = '';
    company = '';
    isAgreed = false;
    has_api_error = false;

    @Mutation
    SET_SUBJECT(value: string) {
        this.subject = value;
    }

    @Mutation
    SET_MESSAGE(value: string) {
        this.message = value;
    }

    @Mutation
    SET_RELATED_CONTENT(value: string) {
        this.relatedContent = value;
    }

    @Mutation
    SET_NAME(value: string) {
        this.name = value;
    }

    @Mutation
    SET_EMAIL(value: string) {
        this.email = value;
    }

    @Mutation
    SET_COMPANY(value: string) {
        this.company = value;
    }

    @Mutation
    SET_IS_AGREED(value: boolean) {
        this.isAgreed = value;
    }

    @Mutation
    SET_HAS_API_ERROR(value: boolean) {
        this.has_api_error = value;
    }

    @MutationAction
    async createInquiry(inquiry: InquirySubmit) {
        try {
            const token = await createCSRFToken();
            setCSRFToken(token);
            await createInquiry(inquiry);
            clearCSRFToken();
        } catch {
            return { has_api_error: true };
        }

        return { has_api_error: false };
    }
}

export const inquiryModule = getModule(Inquiry);
